const filterData = (data, filters) => data.filter(
    item => filters.fields.some(
        f => item[f] && item[f].toLowerCase().includes(
            filters.key.toLowerCase()
        )
    )
)

export default filterData